export default "__VITE_ASSET__CgqPXzDz__"